import { render, staticRenderFns } from "./QuoteProductSubscriptionItemBody.vue?vue&type=template&id=4bb887a1&"
import script from "./QuoteProductSubscriptionItemBody.vue?vue&type=script&lang=ts&"
export * from "./QuoteProductSubscriptionItemBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports